import { AreaWithSensorInfo, type MeetingRoom } from "@lib/store";
import { isArea, isMeetingRoom } from "../helpers";
import { useFeatureToggle } from "@hooks";
import { ExploreState } from "src/components/pages/HereAndNow/useExploreState";
import { Resource } from "@lib/store/src/data/buildingResources";
import { useHereAndNow } from "@pages";
import { HaNRoomList } from "./HaNRoomList";
import { HaNWorkspacesList } from "./HaNWorkspacesList";

export type HaNVerticalListContentProps = {
  exploreState: ExploreState;
  selectedObject: MeetingRoom | AreaWithSensorInfo | Resource | null;
  onClick: (entity: MeetingRoom | AreaWithSensorInfo | Resource) => void;
  startDateTime: string;
  endDateTime: string;
};

export const HaNVerticalListContent = ({
  exploreState,
  onClick,
  selectedObject,
  endDateTime,
  startDateTime,
}: HaNVerticalListContentProps) => {
  const { tab } = useHereAndNow();

  const {
    WorkspacesOnHereAndNow: isWorkspacesOnHereAndNowEnabled,
    HybridMeetingsCalendarView: isHybridMeetingsCalendarViewEnabled,
  } = useFeatureToggle();

  const renderRooms =
    (tab === "rooms" || (!isWorkspacesOnHereAndNowEnabled && !tab)) &&
    (selectedObject === null || isMeetingRoom(selectedObject));

  const renderWorkspaces = tab === "workspaces" && (selectedObject === null || isArea(selectedObject));

  return (
    <>
      {renderRooms && (
        <HaNRoomList
          buildingId={exploreState.buildingId}
          onClick={onClick}
          selectedRoom={selectedObject}
          startDateTime={startDateTime}
          endDateTime={endDateTime}
        />
      )}

      {renderWorkspaces && (
        <HaNWorkspacesList
          onClick={onClick}
          selectedWorkspace={selectedObject}
        />
      )}
    </>
  );
};
